<template>
  <div :title="title" class="flex flex-row items-center border p-2 rounded-sm space-x-2">
    <svg style="width:24px;height:24px" class="fill-current" :class="iconClass" viewBox="0 0 24 24">
      <path v-if="status == 'AP'" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
      <path v-if="status == 'R'" d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" />
      <path v-if="status == null" d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
    </svg>
    <span>{{ setor }}</span>
  </div>
</template>

<script>
export default {
  name: 'ApproveCheckList',
  props: {
    status:  String,
    setor:  String,
  },
  computed: {
    iconClass(){
      return {
        'text-green-600' : this.status == 'AP',
        'text-red-600' : this.status == 'R',
        'text-orange-600' : this.status == null,
      }
    },
    title(){
      if(this.status == 'AP'){
        return 'Aprovado'
      }
      if(this.status == 'R'){
        return 'Rejeitado'
      }
      if(this.status == null){
        return 'Aguardando aprovação do setor'
      }
      return ''
    },
  },
}
</script>

<style>

</style>
